module.exports = __webpack_public_path__ + "static/media/operator.3ffc4b93.png";